import config from '../../../util/config';

export const createVgsCollectForm = <
  VgsSubmitType,
>(): VGSForm<VgsSubmitType> => {
  const form = window.VGSCollect.create(
    config.vgs.vault,
    config.vgs.environment,
    () => null,
  );
  form.useCname(config.vgs.cname);
  return form;
};
